import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { OpeningService } from '../opening.service';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCalculateSalary } from 'app/shared/models/position/dto-calculate-salary.model';
import { saveAs } from 'file-saver';
import { RecruitmentService } from '../../recruitment/recruitment.service';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { Observable } from 'rxjs';
import { IDtoWorkingDay } from 'app/shared/models/position/dto-working-day.model';
@Component({
    selector: 'app-requisition-detail',
    styleUrls: ['./requisition-detail.style.scss'],
    templateUrl: 'requisition-detail.template.html'
})
export class RequisitionDetailComponent implements OnDestroy, OnInit {
    /**Variables */
    private now: number;
    private action = '';
    /**Objetos*/
    private requisition = {} as IDtoRequisition;
    /**Validadores */
    private errorMessages: any;
    /**Notificaciones */
    private configToast: any;
    private profile: string;
    private salary = {} as IDtoCalculateSalary;
    private documents: Observable<IDocument[]>;
    private workingDay = {} as IDtoWorkingDay;
    public constructor(private formBuilder: FormBuilder
        , private recruitmentService: RecruitmentService
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private openingService: OpeningService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService) {
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.getProfile();
        this.now = Date.now();
        this.route.params.subscribe((params) => {
            if (params['id']) {
                setTimeout(() => {
                    this.spinner.show();
                    this.action = params['action'];
                    if (this.configurationService.isReady) {
                        this.getPositionById(Number(params['id']));
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            this.getPositionById(Number(params['id']));
                        });
                    }
                }, 2);
            }
        });
    }
    ngOnDestroy(): void {
    }
    private getProfile(): void {
        this.profile = this.securityService.getProfileStorage('RequisitionReviews');
    }
    private getPositionById(positionId: number): void {
        this.openingService.getPositionById(positionId).subscribe((res) => {
            this.requisition = res.data as IDtoRequisition;
            // this.requisition.recruitmentSourceId = this.requisition.recruitmentSourceId == null ? '0' :  this.requisition.recruitmentSourceId.toString();
            // this.requisition.typeContractId = this.requisition.typeContractId == null ? '0' :  this.requisition.typeContractId.toString();
            if (this.requisition.admissionDate != null) {
                this.requisition.admissionDate = new Date(this.requisition.admissionDate);
            }
            if (this.requisition.hireDate) {
                this.requisition.hireDate = new Date(this.requisition.hireDate);
            }
            if (this.requisition.requestNumber != null) {
                this.getEmployeeByRequisitionId(this.requisition.requestNumber);
            }
            this.getPaymentConceptsForOpening(this.requisition.quoteJobId);
            this.getWorkingDay();
            this.spinner.hide();
        });
    }
    private getEmployeeByRequisitionId(requisitionId: string): void {
        this.openingService.getEmployeeByRequisitionId(requisitionId).subscribe((res) => {
            if (res != null) {
                let employee = res.additional.split('|');
                this.requisition.employeeName = res.text;
                this.requisition.hiringDate = employee[0];
                this.requisition.employeeNum = employee[1];
                this.documents = this.recruitmentService.getJobCandidateDocumentsByJobCandidateId(+res.id);
            }
            this.spinner.hide();
        });
    }
    private getPaymentConceptsForOpening(jobId: number): void {
        this.openingService.getPaymentConceptsForOpening(jobId).subscribe((res) => {
            if (res != null) {
                this.salary = res.data as IDtoCalculateSalary;
            }
            this.spinner.hide();
        });
    }
    private getWorkingDay(): void {
        this.openingService.getWorkingDay(this.requisition.workingDayId).subscribe((res) => {
            if(res != null) {
                this.workingDay = res.data as IDtoWorkingDay;
            }
            this.spinner.hide();
        });
    }
    private downloadFile(item: IDocument): void {
        if (item.id == undefined) {
          return;
        }
        this.recruitmentService.downloadFile(item.id).subscribe((res) => {
          if (res.isCorrect === true) {
            const file = res.data as any;
            const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
            saveAs(blob, file.fileDownloadName);
          } else {
            this.snotifyService.error(res.message
            , 'Error', this.configToast);
          }
        });
      }
      private receiveRequisitionId(id: number) {
        this.requisition.requestNumber = id.toString();
    }
}
